<template>
    <div>
        <div class="container" style="display: flex; align-items: flex-start; padding: 0 30px 30px">
            <div class="leftbox" style="width: 15%">
                <div class="titlea">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item> <i class="el-icon-setting"></i> 表格列设置 </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <ul>
                    <li class="leftColunm">
                        <span class="leftSpan tableHeadSpan">ID</span>
                        <span class="rgSpan tableHeadSpan">名称</span>
                        <span class="verticalLine"></span>
                    </li>
                    <li
                        v-for="(item, index) in selectList"
                        :key="index"
                        v-bind:class="{ bgSelect: item.id == current }"
                        class="leftColunm"
                        @click="selectValue(item.id, item.name)"
                    >
                        <span class="leftSpan">{{ item.id }}</span>
                        <span class="rgSpan">{{ item.name }}</span>
                        <span class="verticalLine"></span>
                    </li>
                </ul>
            </div>
            <div style="width: 85%">
                <div class="handle-box">
                    <div>
                        <el-button type="text" style="color: red" @click="handleClick"> 【注意：本模块仅限工程师使用】 </el-button>
                    </div>
                    <div>
                        <el-button
                            type="primary"
                            v-if="isEditStatus"
                            @click="addTableData"
                            :disabled="!!tableData.table_name1 && !!tableData.table_name2 && !!tableData.table_name3 && !canOperate"
                            >新增表格</el-button
                        >
                        <el-button v-if="isEditStatus" @click="optionCancel">{{ $t('common.cancel') }}</el-button>
                        <el-button type="primary" v-if="!isEditStatus" :disabled="isEditStatus" @click="handleAdd">{{ $t('common.edit') }}</el-button>
                        <el-button type="success" v-else :disabled="!isEditStatus" @click="preservation">{{ $t('common.save') }}</el-button>
                    </div>
                </div>
                <div v-for="table in tables" :key="table.key">
                    <div style="display: flex; align-items: center; cursor: pointer; margin-top: 10px" v-if="tableData[table.nameKey]">
                        <div style="display: flex; align-items: center" @click="table.show = !table.show">
                            <span style="font-size: 14px; display: flex; align-items: center">
                                <i class="el-icon-caret-right" v-if="!table.show" style="color: #409eff; margin-right: 5px"></i>
                                <i class="el-icon-caret-bottom" v-else style="color: #409eff; margin-right: 5px"></i>
                                {{ table.name }}
                            </span>
                        </div>
                        <div>
                            <el-form :inline="true">
                                <el-form-item label="" style="margin-bottom: 0; margin-left: 5px">
                                    <el-input
                                        v-model="tableData[table.nameKey]"
                                        placeholder=""
                                        :disabled="!isEditStatus"
                                        style="height: 36px; line-height: 36px"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div>
                            <el-tag :type="tableData[table.showKey] == 1 ? 'success' : 'danger'">{{
                                tableData[table.showKey] == 1 ? '显示' : '隐藏'
                            }}</el-tag>
                            <el-switch v-model="tableData[table.showKey]" :active-value="1" :inactive-value="0" :disabled="!isEditStatus">
                            </el-switch>
                        </div>
                        <div style="margin-left: 5px">
                            <el-button
                                type="primary"
                                v-if="isEditStatus && tableData[table.nameKey]"
                                @click="addTableData(table.key)"
                                :disabled="!canOperate"
                                >新增行</el-button
                            >
                        </div>
                    </div>

                    <div v-show="table.show && tableData[table.key]">
                        <el-table
                            :data="tableData[table.key]"
                            style="width: 100%; margin-top: 10px"
                            ref="multipleTable"
                            header-cell-class-name="table-header"
                            :key="refushTable + table.key"
                        >
                            <el-table-column type="index" title="序号" width="50" align="center">
                                <template slot="header">
                                    <i class="el-icon-setting" style="font-size: 18px" @click.stop="changeTable(table.key)"></i>
                                </template>
                            </el-table-column>
                            <el-table-column prop="no" label="字段" align="center">
                                <template slot-scope="scope">
                                    <el-input width="100px" v-model="scope.row.no" :disabled="!isEditStatus || !canOperate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="字段名称" align="center">
                                <template slot-scope="scope">
                                    <el-input width="100px" v-model="scope.row.name" :disabled="!isEditStatus"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="显示" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">{{
                                        scope.row.is_show == 1 ? '显示' : '隐藏'
                                    }}</el-tag>
                                    <el-switch
                                        v-model="scope.row.is_show"
                                        style="margin-left: 5px"
                                        :active-value="1"
                                        :inactive-value="0"
                                        :disabled="!isEditStatus"
                                    >
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column prop="size" label="宽度" align="center">
                                <template slot-scope="scope">
                                    <el-input width="100px" v-model="scope.row.size" :disabled="!isEditStatus"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="align" label="对齐方式" align="center">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.align" filterable placeholder="请选择" :disabled="!isEditStatus">
                                        <el-option
                                            v-for="item in optionsList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="font_size" label="字体大小" align="center">
                                <template slot-scope="scope">
                                    <el-input width="100px" v-model="scope.row.font_size" :disabled="!isEditStatus"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" :disabled="!isEditStatus" @click="handleUp(scope.$index, table.key)">上移</el-button>
                                    <el-button type="text" :disabled="!isEditStatus" @click="handleDown(scope.$index, table.key)">下移</el-button>
                                    <el-button
                                        type="text"
                                        :disabled="!isEditStatus || !canOperate"
                                        @click="delCurrentRow(scope.$index, table.key)"
                                        >{{ $t('common.delete') }}</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.is_show == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.is_show == 0"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { apiPrintList, apiPrintListright, apiUpdatePrint, apiCurrentPermisson } from '@/request/api';
export default {
    name: 'tablecolumn',
    data() {
        return {
            drawers: false,
            direction: 'rtl',
            keyList: [],
            showIndex: null,
            optionalIndex: null,
            refushTable: true,

            selectList: [],
            tableData: {},
            perData: '',
            current: 0,
            selectId: '',
            isEditStatus: false,
            optionsList: [
                { value: 'left', label: '居左' },
                { value: 'center', label: '居中' },
                { value: 'right', label: '居右' }
            ],
            // 表格配置
            tables: [
                { key: 'fields1', name: '表格一', nameKey: 'table_name1', showKey: 'is_fields1', show: true },
                { key: 'fields2', name: '表格二', nameKey: 'table_name2', showKey: 'is_fields2', show: true },
                { key: 'fields3', name: '表格三', nameKey: 'table_name3', showKey: 'is_fields3', show: true },
                { key: 'fields4', name: '表格四', nameKey: 'table_name4', showKey: 'is_fields4', show: true }
            ],
            clickCount: 0,
            canOperate: false
        };
    },
    watch: {
        selectId: function (val, oldval) {
            this.getData();
        }
    },
    created() {
        this.canOperate = false;
        this.getListData();
        this.getPermission();
        this.current = 0;
    },
    methods: {
        // 点击十次才为true
        handleClick() {
            this.clickCount++;
            if (this.clickCount >= 10) {
                this.canOperate = true;
            }
        },
        //列配置相关接口
        changeTable(type) {
            this.keyList = this.tableData[type];
            this.drawers = true;
        },

        keyConfirm() {
            this.refushTable = !this.refushTable;
            this.drawers = false;
            this.preservation();
        },

        keycancel() {
            this.drawers = false;
            this.getData();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'is_show', 0);
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'is_show', 1);
            }
        },

        checkMove(item) {},

        handleUp(i, e) {
            if (i > 0) {
                // 确保不是第一行
                const item = this.tableData[e].splice(i, 1)[0]; // 删除当前项
                this.tableData[e].splice(i - 1, 0, item); // 在上方插入
            }
        },
        handleDown(i, e) {
            if (i < this.tableData[e].length - 1) {
                // 确保不是最后一行
                const item = this.tableData[e].splice(i, 1)[0]; // 删除当前项
                this.tableData[e].splice(i + 1, 0, item); // 在下方插入
            }
        },
        // 获取左侧列表信息----------------------------------------------------------------------------------------------------
        getListData() {
            apiPrintList({}).then((res) => {
                if (res.code == 2000) {
                    this.selectList = res.data;
                    this.selectId = res.data[0].id;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取右侧表格信息----------------------------------------------------------------------------------------------------
        getData() {
            this.$load.show();
            apiPrintListright({ id: this.selectId }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    let fieldsData = res.data.fields;
                    // 如果返回的是字符串，尝试解析
                    if (typeof fieldsData === 'string') {
                        try {
                            fieldsData = JSON.parse(fieldsData);
                        } catch (e) {
                            fieldsData = {};
                        }
                    }
                    this.tableData = fieldsData || {};
                    this.keyList = this.tableData.fields1 || [];
                    // 如果 tableData 为空对象，初始化默认数据
                    if (!this.tableData || Object.keys(this.tableData).length === 0) {
                        this.tableData = {
                            table_name1: '表格一',
                            table_name2: '表格二',
                            fields1: [],
                            fields2: []
                        };
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //下拉选择----------------------------------------------------------------------------------------------------
        selectValue(number, name) {
            if (this.isEditStatus == true) {
                this.$message.info('请先退出编辑状态再进行切换');
                return;
            }
            this.selectId = number;
            this.current = number;
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '153'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 编辑----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.isEditStatus = true;
        },

        preservation() {
            this.$load.show();
            // 确保每一行都有 seq 字段，如果没有则按顺序添加
            if (this.tableData && Array.isArray(this.tableData.fields1)) {
                this.tableData.fields1.forEach((row, index) => {
                    // 如果没有 seq 字段，就按顺序给每一行添加 seq
                    row.seq = index + 1; // 从 1 开始顺序编号
                });
            }
            if (this.tableData && Array.isArray(this.tableData.fields2)) {
                this.tableData.fields2.forEach((row, index) => {
                    // 如果没有 seq 字段，就按顺序给每一行添加 seq
                    row.seq = index + 1; // 从 1 开始顺序编号
                });
            }
            if (this.tableData && Array.isArray(this.tableData.fields3)) {
                this.tableData.fields3.forEach((row, index) => {
                    // 如果没有 seq 字段，就按顺序给每一行添加 seq
                    row.seq = index + 1; // 从 1 开始顺序编号
                });
            }
            if (this.tableData && Array.isArray(this.tableData.fields4)) {
                this.tableData.fields4.forEach((row, index) => {
                    // 如果没有 seq 字段，就按顺序给每一行添加 seq
                    row.seq = index + 1; // 从 1 开始顺序编号
                });
            }
            let data = {
                id: this.selectId,
                fields: this.tableData
            };
            apiUpdatePrint(data).then((res) => {
                // console.log(res, 'res');
                if (res.code == 2000) {
                    this.isEditStatus = false;
                } else {
                    this.$message.error(res.data.info);
                }
                this.$load.close();
            });
        },

        delCurrentRow(i, e) {
            this.$confirm('此操作将删除该行，是否继续？', '提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            }).then(() => {
                this.tableData[e].splice(i, 1);
            });
        },
        optionCancel() {
            this.getData();
            this.isEditStatus = false;
        },
        addTableData(field) {
            // 确保 tableData 是对象
            if (typeof this.tableData === 'string') {
                try {
                    this.tableData = JSON.parse(this.tableData);
                } catch (e) {
                    console.error('Failed to parse tableData:', e);
                    this.tableData = {}; // 如果解析失败，初始化为一个空对象
                }
            }

            // 检查 field 是否有效并且是 fields1 或 fields2
            if (field == 'fields1' || field == 'fields2' || field == 'fields3' || field == 'fields4') {
                let data = {
                    is_show: 1,
                    size: 40,
                    align: 'center',
                    font_size: 12
                };

                // 确保目标字段存在并初始化为数组
                if (!Array.isArray(this.tableData[field])) {
                    this.tableData[field] = [];
                }
                this.tableData[field].push(data); // 添加数据到对应的字段
                this.tableData[field].forEach((row, index) => {
                    // 如果没有 seq 字段
                    row.seq = index + 1; // 按顺序生成 seq，从 1 开始
                });
            } else {
                // 如果没有传入有效字段，添加特定格式的数据对象
                const tables = [
                    { key: 'fields1', name: '表格一', titlename: 'table_name1' },
                    { key: 'fields2', name: '表格二', titlename: 'table_name2' },
                    { key: 'fields3', name: '表格三', titlename: 'table_name3' },
                    { key: 'fields4', name: '表格四', titlename: 'table_name4' }
                ];

                let data = {};
                this.tableData = this.tableData || {};

                const missingTable = tables.find((table) => !this.tableData[table.key]);
                if (missingTable) {
                    data = {
                        [missingTable.key]: [{ is_show: 1, size: 40, align: 'center', font_size: 12 }],
                        [missingTable.titlename]: missingTable.name
                    };
                    // console.log(data, '???data');
                }

                // 只合并没有冲突的属性
                for (const key in data) {
                    if (!this.tableData[key]) {
                        this.tableData[key] = data[key];
                    }
                }

                this.$forceUpdate();
            }

            // 调试信息，确认数据已添加
            // console.log('Current tableData:', this.tableData);
        }
    }
};
</script>

<style scoped lang="scss">
.handle-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* margin-bottom: 20px; */
    height: 50px;
    // line-height: 50px;
    text-align: right;
}

.handle-select {
    width: 250px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.leftColunm {
    display: flex;
    justify-content: space-between;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #fff;
    .leftSpan {
        width: 30%;
    }
    .rgSpan {
        width: 70%;
    }
    .verticalLine {
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 32%;
        background-color: #fff;
    }
    .tableHeadSpan {
        font-weight: bold;
    }
}
</style>
<style scoped lang="scss">
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.titlea .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    height: 50px;
    line-height: 50px;
    color: #000;
    font-weight: bold;
    font-size: 16px;
}
.leftbox ul {
    background: #ecf5ff;
    height: 700px;
    overflow-y: scroll;
}
.leftbox ul li {
    list-style: none;
    padding: 10px;
    font-size: 14px;
}
/* .leftbox ul li:last-child{
    border-bottom: 1px solid skyblue;
} */
.bgSelect {
    background: #409eff;
    color: #fff;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
